export const fr = {
    marketOfficeLabel: 'Marché - Bureau',
    marketOfficePlaceholder: 'Sélectionnez un marché/bureau',
    newClaimButton: 'Commencer une nouvelle réclamation',
    newClaimButtonShort: 'Nouvelle réclamation',
    marketOfficeError: 'Veuillez sélectionner un marché et un bureau.',
    phoneCallQuestion:
        'Si vous avez des questions ou préférez signaler des dommages aux États-Unis par téléphone, veuillez appeler :',
    openClaimsTitle: 'Réclamations ouvertes',
    openClaimsClosureWarning:
        "Les réclamations ouvertes sans mise à jour dans les 48 heures sont susceptibles d'être fermées.",
    openClaimsTableDescription:
        "Une liste de toutes les réclamations qui n'ont pas encore été soumises à Phoenix Loss Control.",
    claimNumber: 'Numéro de réclamation',
    claimNumberShort: 'Réclamation #',
    lastUpdate: 'Dernière mise à jour',
    dateReported: 'Date signalée',
    address: 'Adresse',
    client: 'Client',
    clientMarketOffice: 'Client / Marché / Bureau',
    points: 'Points',
    status: 'Statut',
    noOpenClaims: 'Aucune réclamation ouverte',
    completedClaimsTitle: 'Réclamations terminées',
    completedClaimsTableDescription:
        'Une liste de toutes les réclamations qui ont été soumises à Phoenix Loss Control.',
    recovered: 'Récupéré',
    comments: 'Commentaires',
    noCompletedClaims: 'Aucune réclamation terminée',
    hour: 'heure',
    hours: 'heures',
    dropdownOptions: {
        selectOption: 'Sélectionnez une option',
        yes: 'Oui',
        no: 'Non',
        na: 'N/A',
        naNoUnderground: 'N/A - Aucun dommage souterrain',
        unknown: 'Inconnu',
    },
    actions: {
        add: 'Ajouter',
        remove: 'Supprimer',
        edit: 'Modifier',
        delete: 'Supprimer',
        cancel: 'Annuler',
        save: 'Enregistrer',
        update: 'Mettre à jour',
        confirm: 'Confirmer',
        loading: 'Chargement...',
        saving: 'Enregistrement',
        continue: 'Continuer',
        search: 'Rechercher',
        close: 'Fermer',
    },
    damageDetailSummary: {
        header: 'Détails des dommages',
        damageDescription: 'Description des dommages / Commentaires généraux',
        subsAffected: "Nombre estimé d'abonnés affectés",
        outageDuration: 'Durée de la panne',
        activityType: "Type d'activité",
        damageBy: 'Dommages causés par',
        facilities: 'Installations',
        wereLocatesPresent: 'Les localisations étaient-elles présentes ?',
        locateAccuracy: 'Précision des localisations',
        locateMarkings: 'Marquages des localisations',
        spanReplacement: 'Un remplacement de portée était-il nécessaire ou la fibre était-elle endommagée ?',
        cableInConduit: 'Le câble souterrain était-il dans une gaine ?',
        spanFootage: 'Longueur de portée endommagée/remplacée',
        otherMaterial: 'Taille du câble / Nombre de fibres / Autre matériel',
    },
    damageDescription: {
        header: 'Description des dommages',
        descriptionLabel: 'Description des dommages / Commentaires généraux',
        descriptionTooltip:
            "Entrez des détails tels que : Qu'est-ce qui a été endommagé ?\n" +
            'Comment cela a-t-il été endommagé ? Portée des travaux\n' +
            "effectués lorsque les dommages sont survenus ? Avez-vous marqué les dommages ? Avez-vous des commentaires sur les marquages des localisations s'ils étaient présents ? Si souterrain et non exposé,\n" +
            "à quelle distance des dommages se trouvent-ils d'un point de repère particulier ? Des numéros de rapport de police ? D'autres commentaires ?",
        subsAffectedLabel: "Nombre estimé d'abonnés affectés",
        subsAffectedTooltip: "Combien d'abonnés ont été affectés par les dommages ?",
        outageDurationLabel: 'Durée de la panne',
        outageDurationTooltip: 'Combien de temps les clients affectés ont-ils été hors service ?',
        activityTypeLabel: "Type d'activité",
        activityTypeTooltip: "Quelle était l'activité qui a causé les dommages ?",
        damageByLabel: 'Dommages causés par',
        damageByTooltip: "Qu'est-ce qui a causé les dommages ?",
    },
    damageLocation: {
        header: 'Adresse des dommages',
        streetAddressLabel: 'Adresse de la rue',
        streetAddressTooltip:
            "Quelle est l'adresse de la rue du lieu des dommages ? Ne pas confondre avec l'adresse du client affecté. Si dans une zone rurale ou une nouvelle construction, quelles sont les coordonnées GPS ?",
        crossStreetLabel: 'Rue transversale',
        crossStreetTooltip:
            "Quelle est la rue transversale la plus proche de l'adresse des dommages ou de l'intersection ?",
        cityLabel: 'Ville',
        cityTooltip: 'Dans quelle ville les dommages ont-ils eu lieu ?',
        stateLabel: 'État',
        statePlaceholder: 'Sélectionnez un état',
        stateTooltip: 'Dans quel état les dommages ont-ils eu lieu ?',
        provinceLabel: 'Province',
        provincePlaceholder: 'Sélectionnez une province',
        provinceTooltip: 'Dans quelle province les dommages ont-ils eu lieu ?',
        zipCodeLabel: 'Code postal',
        zipCodeTooltip: 'Quel est le code postal du lieu des dommages ?',
    },
    aerialDamage: {
        wasAerialLabel: 'Les installations aériennes ont-elles été endommagées ?',
        wasAerialTooltip: 'Des dommages ont-ils eu lieu au-dessus du sol ?',
        facilityNumberLabel: 'Ped / Poteau / Amp',
        facilityNumberTooltip:
            "Le piédestal ou l'AMP endommagé a-t-il un numéro/nom assigné ? Le poteau a-t-il un numéro attaché ?",
    },
    damageType: {
        header: 'Type de dommage',
        locationLabel: 'Emplacement',
        locationTooltip:
            "Quel est le type d'emplacement ? Par exemple, les dommages ont-ils eu lieu dans l'emprise, sous la chaussée, etc. ?",
    },
    internalIdentifications: {
        header: 'Identifications internes',
        hubLabel: 'Hub',
        hubTooltip: 'Quel hub/entrée utilisez-vous ?',
        nodeLabel: 'Nœud',
        nodeTooltip: 'Quels nœuds sont affectés par ces dommages ?',
        nodeCheckboxLabel: 'Nœud inconnu',
        outageIdLabel: 'ID de panne',
        outageIdTooltip: 'Quel est le numéro de panne, de travail ou de commande associé à ces dommages ?',
    },
    times: {
        header: 'Dates et heures',
        damageDateLabel: 'Date des dommages',
        damageDateTooltip: "La date et l'heure auxquelles les dommages ont eu lieu.",
        damageDateError: 'La date des dommages ne peut pas être postérieure à la date de découverte.',
        damageTimeLabel: 'Heure des dommages',
        damageDateUnknownCheckbox: 'La date des dommages est inconnue',
        discoveryDateLabel: 'Date de découverte',
        discoveryDateTooltip: "La date et l'heure auxquelles les dommages ont été découverts.",
        discoveryDateError: 'La date de découverte ne peut pas être antérieure à la date des dommages.',
        discoveryTimeLabel: 'Heure de découverte',
        discoveryDateSameCheckbox: 'La date de découverte est la même que la date des dommages',
    },
    undergroundDamage: {
        wasUndergroundLabel: 'Les installations souterraines ont-elles été endommagées ?',
        wasUndergroundTooltip: 'Des dommages ont-ils eu lieu sous le sol ?',
        depthOfDamageLabel: 'Profondeur des dommages',
        depthOfDamageTooltip: 'À quelle profondeur le câble était-il enterré sur le site des dommages ?',
    },
    facilities: {
        header: 'Installations',
        label: 'Installations',
        placeholder: "Sélectionnez tout ce qui s'applique",
        tooltip: "Quel type d'installations ont été endommagées ?",
    },
    locateMarkings: {
        label: 'Marquages de localisation',
        tooltip: 'Comment la localisation a-t-elle été marquée ?',
        flagsLabel: 'Drapeaux',
        flagsAriaLabel: 'Drapeaux de marquage',
        paintLabel: 'Peinture',
        paintAriaLabel: 'Peintures de marquage',
        stakesLabel: 'Piquets',
        stakesAriaLabel: 'Piquets de marquage',
        unknownLabel: 'Inconnu',
        unknownAriaLabel: 'Marquage inconnu',
    },
    locates: {
        header: 'Localisations',
        wereLocatesPresentLabel: 'Les localisations étaient-elles présentes ?',
        wereLocatesPresentTooltip: 'Les localisations étaient-elles présentes sur le lieu des dommages ?',
        locateAccuracyLabel: 'Précision de la localisation',
        locateAccuracyTooltip: 'Notez si les localisations étaient visibles et précises ou non.',
    },
    spanReplacement: {
        header: 'Remplacement de la portée',
        wasSpanReplacementNeededLabel:
            'Le remplacement de la portée était-il nécessaire OU la fibre était-elle endommagée ?',
        wasSpanReplacementNeededTooltip:
            "Un remplacement d'une longueur de câble/fibre a-t-il été effectué sur place ou sera-t-il nécessaire à l'avenir (si une réparation temporaire a été effectuée) ?",
        wasCableInConduitLabel: 'Le câble souterrain était-il dans un conduit ?',
        wasCableInConduitTooltip: 'Le câble était-il logé dans un conduit ?',
        spanFootageLabel: 'Portée endommagée/remplacée',
        spanFootageTooltip: 'Quelle est la longueur de la portée endommagée/remplacée ?',
        cableSizeLabel: 'Taille du câble / Nombre de fibres / Autre matériel',
        cableSizeTooltip:
            'Quelle est la taille du câble ou des autres matériaux ? (piédestal, alimentation, fibre 288 ct., .750, .500, etc.)',
        spanFootageUnknownCheckbox: 'Portée remplacée inconnue',
        cableSizeUnknownCheckbox: 'Taille du câble, nombre de fibres, autre matériel inconnu',
    },
    damagerKnown: {
        header: 'Dommageur connu',
        isDamagerKnownLabel: 'Savez-vous qui est le dommageur ?',
        isDamagerKnownTooltip: 'À ce moment, le dommageur est-il connu ou inconnu ?',
        damagerNameLabel: 'Nom du dommageur',
        damagerNameTooltip: "Quel est le nom/nom de l'entreprise du dommageur suspecté ?",
        damagerIdentifiedLabel: 'Comment le dommageur a-t-il été identifié ?',
        damagerIdentifiedTooltip: 'Comment avez-vous identifié le dommageur suspecté ?',
        isDamagerContactDetailsKnownLabel: 'Avez-vous les coordonnées ou une déclaration du dommageur ?',
        isDamagerContactDetailsKnownTooltip:
            'Les coordonnées du dommageur sont-elles connues ? Avez-vous une déclaration du dommageur ?',
        damagerContactNameLabel: 'Nom du contact du dommageur',
        damagerContactNameTooltip:
            "Si connu, qui est le point de contact pour l'entreprise ? – par exemple, contremaître, surintendant, directeur général, propriétaire, etc.",
        damagerPhoneNumberLabel: 'Numéro de téléphone du dommageur',
        damagerPhoneNumberTooltip: 'Quel est le numéro de téléphone où le dommageur peut être joint ?',
        damagerEmailAddressLabel: 'Adresse email du dommageur',
        damagerEmailAddressTooltip: "Quelle est l'adresse email où le dommageur peut être joint ?",
        damagerStatementLabel: 'Déclaration du dommageur',
        damagerStatementTooltip: 'Le dommageur a-t-il fait des remarques sur les dommages ?',
    },
    damagerOpinion: {
        header: 'Opinion du dommageur',
        hasOpinionLabel: 'Avez-vous une opinion sur qui était responsable des dommages ?',
        hasOpinionTooltip: 'Pensez-vous savoir qui pourrait être responsable des dommages ?',
        responsiblePartyLabel: 'Qui était responsable des dommages ?',
        responsiblePartyTooltip: 'Qui pensez-vous être responsable des dommages ?',
    },
    futureRepairs: {
        header: 'Réparations futures',
        areFutureRepairsNeededLabel: "Un remplacement de portée ou d'autres réparations futures sont-ils nécessaires ?",
        areFutureRepairsNeededTooltip: 'Des réparations futures seront-elles nécessaires sur le lieu des dommages ?',
        clientConstructionNumberLabel: 'Numéro de construction du client',
        clientConstructionNumberTooltip: 'Le numéro de suivi de la construction de votre entreprise, si disponible.',
        clientConstructionNumberUnknownCheckbox: 'Numéro de construction du client inconnu',
        constructionCoordinatorLabel: 'Coordinateur de construction',
        constructionCoordinatorTooltip: 'Le coordinateur de construction pour la réclamation.',
        constructionCoordinatorEmailLabel: 'Adresse email du coordinateur de construction',
        constructionCoordinatorEmailTooltip: 'Adresse email du coordinateur de construction',
        constructionCoordinatorPhoneLabel: 'Numéro de téléphone du coordinateur de construction',
        constructionCoordinatorPhoneTooltip: 'Numéro de téléphone du coordinateur de construction',
        createNewCoordinatorOption: 'Créer un nouveau coordinateur de construction - "{searchText}"',
    },
    laborDetails: {
        personnelHeader: 'Personnel',
        materialsHeader: 'Matériaux',
        vehiclesHeader: 'Véhicules',
    },
    materials: {
        materialTypeLabel: 'Type de matériau',
        materialTypeTooltip:
            'Quels matériaux avez-vous utilisés pour effectuer la réparation ? par exemple, 200’ de câble RG11, 2 connecteurs RG11, 2 Pin-Fs',
        materialTypePlaceholder: 'Commencez à taper pour voir les types de matériaux...',
        quantityLabel: 'Longueur / Quantité',
        quantityTooltip: 'La quantité totale de matériau utilisé.',
        confirmDeleteTitle: 'Confirmer la suppression',
        confirmDeleteMessage: 'Êtes-vous sûr de vouloir supprimer ce matériau ?',
    },
    materialTable: {
        nameHeader: 'Nom',
        quantityHeader: 'Quantité',
        emptyMessage: 'Aucun matériau ajouté',
    },
    personnel: {
        personnelTypeLabel: 'Type de personnel',
        personnelTypeTooltip:
            'Combien de personnes ont travaillé sur cette réparation ? par exemple, 10/18/21 Paul Jones, OSP Tech, 1 heure de temps régulier et 2 heures en heures supplémentaires.',
        personnelTypePlaceholder: 'Commencez à taper pour voir les types de personnel...',
        regularTimeLabel: 'Temps',
        regularTimeTooltip: "Combien d'heures non supplémentaires le(s) technicien(s) ont-ils travaillé ?",
        overtimeLabel: 'Heures supplémentaires',
        overtimeTooltip: "Combien d'heures supplémentaires le(s) technicien(s) ont-ils travaillé ?",
        confirmDeleteTitle: 'Confirmer la suppression',
        confirmDeleteMessage: 'Êtes-vous sûr de vouloir supprimer ce personnel ?',
    },
    personnelTable: {
        positionHeader: 'Position',
        timeHeader: 'Temps',
        overtimeHeader: 'Heures supplémentaires',
        emptyMessage: 'Aucun personnel ajouté',
    },
    repairs: {
        header: 'Réparations',
        repairsDoneOnSiteLabel: 'Les réparations sur site ont-elles été commencées/terminées ?',
        repairsDoneOnSiteTooltip:
            'Les réparations sur site ont-elles été commencées/terminées, ou avez-vous du travail à signaler ?',
        referenceLabel: 'Référence / Travail de construction / Autre référence de travail interne',
        referenceTooltip:
            "S'il y a un autre numéro de référence interne de l'entreprise associé à ces dommages, tel qu'un numéro de travail pour le département de construction pour effectuer un remplacement de portée, entrez-le ici.",
    },
    vehicles: {
        vehicleTypeLabel: 'Type de véhicule',
        vehicleTypeTooltip: 'Quels véhicules ont été utilisés lors de la réalisation des réparations ?',
        vehicleTypePlaceholder: 'Commencez à taper pour voir les types de véhicules...',
        regularTimeLabel: 'Temps',
        regularTimeTooltip: "Combien d'heures le véhicule a-t-il été utilisé ?",
        confirmDeleteTitle: 'Confirmer la suppression',
        confirmDeleteMessage: 'Êtes-vous sûr de vouloir supprimer ce véhicule ?',
    },
    vehicleTable: {
        vehicleTypeHeader: 'Type de véhicule',
        timeHeader: 'Temps',
        emptyMessage: 'Aucun véhicule ajouté',
    },
    damageDetailsSummary: {
        stepLink: 'Détails des dommages',
        damageDescriptionLabel: 'Description des dommages / Commentaire général',
        estimatedSubsAffectedLabel: 'Nombre estimé de sous-affectés',
        outageDurationLabel: 'Durée de la panne',
        activityTypeLabel: "Type d'activité",
        damageByLabel: 'Dommages par',
        facilitiesLabel: 'Installations',
        wereLocatesPresentLabel: 'Les localisations étaient-elles présentes ?',
        locateAccuracyLabel: 'Précision de la localisation',
        locateMarkingsLabel: 'Marquages de localisation',
        spanReplacementNeededLabel:
            'Le remplacement de la portée était-il nécessaire ou la fibre était-elle endommagée ?',
        cableInConduitLabel: 'Le câble souterrain était-il dans un conduit ?',
        spanFootageLabel: 'Portée endommagée/remplacée',
        cableSizeLabel: 'Taille du câble / Nombre de fibres / Autre matériel',
    },
    damagerDetailsSummary: {
        stepLink: 'Détails du dommageur',
        opinionLabel: 'Avez-vous une opinion sur qui était responsable des dommages ?',
        responsiblePartyLabel: 'Qui était responsable des dommages ?',
        isDamagerKnownLabel: 'Savez-vous qui est le dommageur ?',
        damagerNameLabel: 'Nom du dommageur',
        howWasDamagerIdentifiedLabel: 'Comment le dommageur a-t-il été identifié ?',
        haveDamagerDetailsLabel: 'Avez-vous les coordonnées ou une déclaration du dommageur ?',
        damagerContactNameLabel: 'Nom du contact du dommageur',
        damagerPhoneNumberLabel: 'Numéro de téléphone du dommageur',
        damagerEmailAddressLabel: 'Adresse email du dommageur',
        damagerStatementLabel: 'Déclaration du dommageur',
    },
    locationDetailsSummary: {
        stepLink: "Détails de l'emplacement",
        damageDateLabel: 'Date des dommages',
        damageTimeLabel: 'Heure des dommages',
        discoveryDateLabel: 'Date de découverte',
        discoveryTimeLabel: 'Heure de découverte',
        streetAddressLabel: 'Adresse de la rue',
        crossStreetLabel: 'Rue transversale',
        cityLabel: 'Ville',
        stateLabel: 'État',
        zipCodeLabel: 'Code postal',
        locationTypeLabel: "Type d'emplacement",
        aboveGroundFacilitiesLabel: 'Les installations aériennes ont-elles été endommagées ?',
        pedPoleAmpLabel: 'Ped - Poteau - Amp',
        undergroundFacilitiesLabel: 'Les installations souterraines ont-elles été endommagées ?',
        depthOfDamageLabel: 'Profondeur des dommages',
        hubLabel: 'Hub',
        nodeLabel: 'Nœud',
        outageIdLabel: 'ID de panne',
    },
    materialSummary: {
        stepLink: 'Matériaux',
        noMaterialsMessage: "Aucun matériau n'a été ajouté à cette réclamation.",
        nameHeader: 'Nom',
        quantityHeader: 'Longueur / Quantité',
    },
    personnelSummary: {
        stepLink: 'Personnel',
        noPersonnelMessage: "Aucun personnel n'a été ajouté à cette réclamation.",
        titleHeader: 'Titre',
        regularHeader: 'Régulier',
        overtimeHeader: 'Heures supplémentaires',
        regularTimeHeader: 'Temps régulier',
    },
    photosAndDocumentsSummary: {
        stepLink: 'Photos et documents',
        noFilesMessage: "Aucun fichier n'a été ajouté à cette réclamation.",
    },
    repairDetailsSummary: {
        stepLink: 'Détails des réparations',
        repairsDoneOnSiteLabel: 'Les réparations sur site ont-elles été commencées/terminées ?',
        referenceLabel: 'Référence / Travail de construction / Autre référence de travail interne',
        futureRepairsNeededLabel: 'Des réparations futures sont-elles nécessaires ?',
        constructionCoordinatorNameLabel: 'Nom du coordinateur de construction',
        constructionCoordinatorEmailLabel: 'Email du coordinateur de construction',
        constructionCoordinatorPhoneLabel: 'Téléphone du coordinateur de construction',
        additionalCommentsLabel: 'Commentaires supplémentaires sur les réparations',
        repairDetailsLabel: 'Détails des réparations',
    },
    vehicleSummary: {
        stepLink: 'Véhicules',
        noVehiclesMessage: "Aucun véhicule n'a été ajouté à cette réclamation.",
        nameHeader: 'Nom',
        regularTimeHeader: 'Temps régulier',
    },
    uploadedFiles: {
        removeButton: 'Supprimer',
        removingBusyText: 'Suppression en cours',
        confirmRemoveTitle: 'Confirmer la suppression',
        confirmRemoveMessage: 'Êtes-vous sûr de vouloir supprimer "{fileName}" ?',
    },
    buttonBar: {
        exitButton: 'Quitter',
        saveAndQuitButton: 'Enregistrer et quitter',
        previousButton: 'Précédent',
        nextButton: 'Suivant',
        completeButton: 'Terminer',
        confirmSubmitTitle: 'Confirmer la soumission',
        confirmSubmitMessage: 'Êtes-vous sûr de vouloir soumettre cette réclamation ?',
        confirmSaveAndQuitTitle: "Confirmer l'enregistrement et la sortie",
        confirmSaveAndQuitMessage:
            'Êtes-vous sûr de vouloir enregistrer cette réclamation et retourner au tableau de bord ?',
        confirmCancelTitle: 'Retourner au tableau de bord ?',
        confirmCancelMessage: 'Êtes-vous sûr de vouloir retourner au tableau de bord ?',
    },
    repairDetails: {
        freeFormQuestion:
            "Souhaitez-vous entrer les détails des réparations sous forme de texte libre, ou souhaitez-vous utiliser des listes déroulantes pour choisir des types spécifiques de main-d'œuvre, de matériaux et de véhicules ?",
        freeFormTooltip: 'Comment souhaitez-vous entrer les détails des réparations ?',
        freeFormNoText: 'Texte',
        freeFormYesText: 'Champs',
        repairDetailsWarning:
            'Veuillez fournir des détails sur les réparations sur site. Veuillez inclure des notes, le cas échéant, sur le personnel présent sur site et la durée de leur présence (par exemple, deux techniciens fibre pendant 2 heures), les matériaux utilisés et leurs quantités (par exemple, 100 pieds de câble RG-11), et les véhicules présents sur site et la durée de leur présence (par exemple, un camion nacelle pendant deux heures).',
        repairDetailsLabel: 'Détails des réparations',
        repairDetailsTooltip: 'Entrez les détails des réparations.',
        additionalCommentsLabel: 'Commentaires supplémentaires sur les réparations',
        additionalCommentsTooltip: 'Avez-vous autre chose à ajouter sur les réparations ?',
    },
    summaryDetails: {
        additionalCommentsLabel: 'Commentaires supplémentaires',
        additionalCommentsTooltip: 'Avez-vous des commentaires supplémentaires sur la réclamation ?',
    },
    uploadPhotosAndDocs: {
        header: 'Télécharger des photos et des documents',
        fileUploadTitle: 'Téléchargement de fichiers',
        fileDescriptionTitle: 'Description du fichier',
        fileNameLabel: 'Nom du fichier :',
        fileDescriptionLabel: 'Description du fichier :',
        description: 'Description',
        errorUploadingMessage: 'Erreur de téléchargement. Veuillez réessayer.',
        successUploadingMessage: 'Fichier(s) téléchargé(s) avec succès !',
        successRemovingMessage: 'Fichier supprimé avec succès !',
        duplicateFilesMessage: 'Les fichiers suivants ont déjà été téléchargés :',
        removeDuplicatesMessage: 'Veuillez les supprimer avant de télécharger à nouveau.',
    },
    claimWizard: {
        requiredFieldWarning1: "Les champs marqués d'un ",
        requiredFieldWarning2: ' sont obligatoires.',
        steps: {
            locationDetails: "Détails de l'emplacement",
            photosAndDocs: 'Photos et documents',
            damageDetails: 'Détails des dommages',
            damagerDetails: 'Détails du dommageur',
            repairDetails: 'Détails des réparations',
            summaryDetails: 'Détails du résumé',
            locationShort: 'Emplacement',
            uploadShort: 'Télécharger',
            damageShort: 'Dommages',
            damagerShort: 'Dommageur',
            repairShort: 'Réparations',
            summaryShort: 'Résumé',
        },
        cmoPlaceholder: '{clientName} / {marketName} / {officeName}',
    },
    fileUpload: {
        command: 'Choisissez des fichiers ou glissez-les ici',
        sizeRestrictionLine1:
            'Vous pouvez télécharger plusieurs fichiers mais la taille totale ne doit pas dépasser 50 Mo.',
        sizeRestrictionLine2: 'Si vous avez plus de 50 Mo, veuillez télécharger par lots.',
        uploading: 'Téléchargement...',
    },
    resources: 'Ressources',
    technician: {
        header: 'Technicien',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        phoneNumber: 'Numéro de téléphone',
        emailAddress: 'Adresse email',
        supervisorEmailAddress: 'Adresse email du superviseur',
        username: "Nom d'utilisateur",
        usernameSpaced: "Nom d'utilisateur",
        uniqueEmailError: 'Un compte avec cette adresse email existe déjà.',
        usernameTooltip:
            "Le nom d'utilisateur unique du technicien choisi lors de la création du compte. Cela ne peut pas être changé.",
        firstNameTooltip: 'Le prénom du technicien.',
        lastNameTooltip: 'Le nom de famille du technicien.',
        phoneNumberTooltip: 'Un numéro de téléphone où le technicien peut être joint.',
        emailAddressTooltip: 'Une adresse email où le technicien peut être joint.',
    },
    supervisor: {
        header: 'Superviseur',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        phoneNumber: 'Numéro de téléphone',
        emailAddress: 'Adresse email',
        firstNameTooltip: 'Le prénom du superviseur du technicien.',
        lastNameTooltip: 'Le nom de famille du superviseur du technicien.',
        phoneNumberTooltip: 'Un numéro de téléphone où le superviseur du technicien peut être joint.',
        emailAddressTooltip: 'Une adresse email où le superviseur du technicien peut être joint.',
    },
    cmoSelection: {
        header: 'Marchés et bureaux',
        markets: 'Marchés',
        offices: 'Bureaux',
        selectMarket: 'Sélectionnez un marché.',
        selectOffice: 'Sélectionnez un bureau.',
        removalMessage: 'Êtes-vous sûr de vouloir supprimer ce marché/bureau ?',
        removalTitle: 'Confirmer la suppression',
    },
    menuOptions: {
        signedInAs: 'Connecté en tant que',
        signOut: 'Déconnexion',
        confirmSignOut: 'Êtes-vous sûr de vouloir vous déconnecter ?',
        signIn: 'Connexion',
        register: 'Inscription',
        dashboard: 'Tableau de bord',
        dashboardReturnMessage: 'Êtes-vous sûr de vouloir retourner au tableau de bord ?',
        dashboardReturnTitle: 'Retourner au tableau de bord ?',
        updateContactInfo: 'Mettre à jour les informations de contact',
        darkMode: 'Passer en mode sombre',
        lightMode: 'Passer en mode clair',
    },
    mainMenu: {
        landingMessage: 'Veuillez vous connecter ou créer un nouveau compte',
    },
    registration: {
        workEmailAddress: 'Adresse e-mail professionnelle',
        workEmailAddressTooltip: 'Quelle est votre adresse e-mail professionnelle?',
        possibleClients: 'Clients potentiels',
        possibleClientsTooltip: "Veuillez sélectionner le client correct ou l'option non trouvée.",
        notFound: 'Non trouvé',
        workEmailAddressInstructions:
            'Veuillez entrer votre adresse e-mail professionnelle ci-dessous afin que nous puissions tenter de vous associer à un client.',
        registerTextExistingLogin: "Enregistrement d'une connexion existante!",
        registerTextExistingTech: "Enregistrement d'une technologie de rapport existante!",
        accountAlreadyExists: 'Un compte avec cette adresse e-mail existe déjà.',
        allClients: 'Tous les clients',
        allClientsTooltip: 'Veuillez sélectionner le client pour lequel vous travaillez.',
        existingClient: 'Client existant',
        existingClientTooltip:
            'Le client pour lequel vous travaillez a été identifié par vos réclamations précédentes.',
        registerAccountHeader: 'Enregistrer un compte',
        userNameTaken: "Le nom d'utilisateur est déjà pris.",
        technicianDetailsHeader: 'Détails du technicien',
        supervisorDetailsHeader: 'Détails du superviseur',
        firstNameTooltip: 'Le prénom du technicien.',
        lastNameTooltip: 'Le nom de famille du technicien.',
        usernameTooltip: "Le nom d'utilisateur unique pour le compte.",
        phoneNumberTooltip: 'Un numéro de téléphone pour le technicien.',
        emailAddressTooltip: 'Une adresse e-mail pour le technicien.',
        supervisorFirstNameTooltip: 'Le prénom du superviseur.',
        supervisorLastNameTooltip: 'Le nom de famille du superviseur.',
        supervisorPhoneNumberTooltip: 'Un numéro de téléphone pour le superviseur.',
        supervisorEmailAddress: 'Adresse e-mail du superviseur',
        supervisorEmailAddressTooltip: 'Une adresse e-mail pour le superviseur du technicien.',
        confirmEmailAddress: "Confirmer l'adresse e-mail",
        confirmEmailAddressTooltip: "Confirmez l'adresse e-mail du technicien.",
        password: 'Mot de passe',
        passwordTooltip:
            'Un mot de passe pour le technicien. Doit comporter au moins 8 caractères. Doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial.',
        confirmPassword: 'Confirmer le mot de passe',
        confirmPasswordTooltip: 'Confirmez le mot de passe du technicien.',
        passwordWarning:
            'Le mot de passe doit comporter au moins 8 caractères et contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial.',
        selectMarketOfficeError: 'Vous devez sélectionner au moins une combinaison marché/bureau.',
        selectMarketTooltip: 'Sélectionnez un marché pour voir les bureaux',
        selectMarketPlaceholder: 'Ajouter un marché',
        selectOfficeTooltip: 'Sélectionnez le bureau pour lequel vous souhaitez soumettre des réclamations',
        selectOfficePlaceholder: 'Ajouter un bureau',
        changeEmailMessage:
            'Veuillez ressaisir votre mot de passe ou en créer un nouveau. Vous serez déconnecté et devrez vous reconnecter avec vos informations de connexion mises à jour.',
    },
    signInModal: {
        title: 'Connexion requise',
        message: 'Vos informations de connexion ont changé. Vous serez redirigé pour vous reconnecter.',
    },
    crashScreen: {
        title: "Oh non! Quelque chose s'est mal passé!",
        line1: 'Si vous continuez à rencontrer des difficultés pour vous connecter, veuillez contacter',
        byPhone: ' par téléphone au',
        byEmail: ' ou par email à',
        returnToLoginScreen: "Retour à l'écran de connexion",
    },
    updateContactInfo: {
        title: 'Mettre à jour les informations de contact',
        subtitle: 'Veuillez garder ces informations à jour',
        close: 'Fermer le panneau de mise à jour des informations de contact',
        confirmationMessage: 'Êtes-vous sûr de vouloir mettre à jour les informations de contact?',
        confirmationTitle: 'Confirmer la mise à jour',
    },
    profile: {
        confirmMessage: 'Veuillez confirmer que nous avons les bonnes informations de profil.',
        confirmButton: 'Confirmer',
        confirmUpdateMessage: 'Êtes-vous sûr de vouloir mettre à jour les informations de contact ?',
        confirmUpdateTitle: 'Confirmer la mise à jour',
        updateSuccess: 'Informations de profil mises à jour avec succès !',
    },
    validation: {
        emailRequired: 'Une adresse e-mail est requise.',
        emailInvalid: 'Une adresse e-mail valide est requise.',
        confirmEmailRequired: "Une confirmation de l'adresse e-mail est requise.",
        emailMismatch: "L'adresse e-mail ne correspond pas.",
        firstNameRequired: 'Un prénom est requis.',
        lastNameRequired: 'Un nom de famille est requis.',
        phoneRequired: 'Un numéro de téléphone est requis.',
        phoneInvalid: 'Un numéro de téléphone valide est requis.',
        passwordsDoNotMatch: 'Les mots de passe ne correspondent pas.',
        confirmPasswordRequired: 'Un mot de passe de confirmation est requis.',
        passwordRequired: 'Un mot de passe valide est requis.',
        passwordInvalid: 'Le mot de passe ne correspond pas au format requis.',
        supervisorEmailRequired: 'Une adresse e-mail est requise.',
        supervisorEmailInvalid: 'Une adresse e-mail valide est requise.',
        supervisorFirstNameRequired: 'Un prénom est requis.',
        supervisorLastNameRequired: 'Un nom de famille est requis.',
        supervisorPhoneRequired: 'Un numéro de téléphone est requis.',
        supervisorPhoneInvalid: 'Un numéro de téléphone valide est requis.',
        userNameRequired: "Un nom d'utilisateur est requis.",
        isRequired: 'est requis.',
        invalidZipCode: 'Invalide code postal.',
        defaultRequired: 'Une réponse est requise.',
    },
    locateAccuracies: {
        49: 'Les localisations semblent précises',
        50: 'Les localisations semblent fausses/dans la mauvaise zone',
        51: 'Les marques de localisation sont effacées/non visibles',
        52: 'Les localisations sont présentes mais pas pour nos installations endommagées',
        53: 'Inconnu',
        54: 'Billet de localisation invalide',
    },
    damageActivityTypes: {
        1: 'Démontage Aérien',
        2: 'Vol de Câble',
        6: 'Incendie',
        10: 'Irrigation',
        11: 'Paysagisme',
        12: 'Véhicule à Moteur',
        17: 'Toiture',
        22: 'Train',
        25: "Élagage d'Arbres",
        26: 'Télévision par Câble',
        27: 'Caniveau/Égout Pluvial',
        28: 'Clôture',
        29: 'Gaz Naturel',
        30: 'Inconnu/Autre',
        31: 'Égout',
        32: 'Panneau de Signalisation',
        33: 'Travaux Routiers',
        34: 'Télécommunications',
        35: 'Eau',
        36: 'Agriculture',
        37: 'Bordure/Trottoir',
        38: 'Construction de Bâtiment',
        39: 'Démolition de Bâtiment',
        40: 'Allée',
        41: 'Électricité',
        42: 'Ingénierie/Arpentage',
        43: 'Nivellement',
        44: 'Pipeline de Liquide',
        45: 'Fraisage',
        46: 'Poteau',
        47: 'Autorité de Transport Public',
        48: 'Chemin de Fer',
        49: 'Drainage',
        50: 'Aménagement du Site',
        51: 'Vapeur',
        52: 'Réverbère',
        53: 'Feu de Circulation',
        54: 'Amélioration des Voies Navigables',
    },
    damageByTypes: {
        1: 'Grue',
        3: 'Camion-Benne',
        5: 'Forage',
        7: 'Vol de Câble',
        8: 'Tarière',
        11: 'Équipement Agricole',
        13: 'Véhicule à Moteur',
        16: 'Couvreurs',
        18: 'Tracteur',
        19: 'Train',
        20: 'Trancheuse',
        23: 'Tronçonneuse',
        24: 'Chasse-Neige',
        25: "Élagueur d'Arbres",
        26: 'Camion à Ordures',
        29: 'Pelle Rétro/Tractopelle',
        30: 'Bouteur',
        33: 'Niveleuse/Racleuse',
        35: 'Inconnu/Autre',
        36: 'Outils à Main',
        37: 'Perçage',
        38: 'Forage Directionnel',
        39: 'Explosifs',
        40: 'Équipement de Fraisage',
        41: 'Dispositif de Sondage',
        42: 'Équipement de Vide',
    },
    damageFacilityTypes: {
        1: 'Câble Aérien',
        2: 'Fibre Enterrée',
        3: 'Poteau',
        4: 'Chambre de Service',
        5: 'Nouvelle Installation',
        6: 'Installations Intérieures',
        7: 'Service Aérien',
        8: 'Câble Enterré',
        9: 'Service de Dérivation',
        10: 'Socle/Enceinte/Boîte AP',
        11: 'Fibre Aérienne',
        14: 'Boîtier / Coupleur de Boîtier / DC9 / Répartiteur',
        15: "Véhicule de l'Entreprise",
        16: 'Conduit/Ligne de Conduite',
        17: 'Aucun Dommage au Câble',
        18: 'Alimentation Électrique',
        19: 'Ligne Temporaire',
        20: 'Distribution',
        21: 'Collecte',
        22: 'Transmission',
        23: 'Réverbère',
        24: 'Clôture/Portail',
        25: 'Bâtiment',
        26: 'Tour de Transmission',
        27: 'Transformateur',
        28: 'Compteur',
        29: 'Restitution',
        30: "Hauban d'Ancrage",
    },
    damageLocationTypes: {
        12: 'Vol de Câble',
        18: 'Privé - Propriétaire Terrien',
        19: 'Public - Autre',
        20: 'Privé - Entreprise',
        22: 'Inconnu/Autre',
        23: 'Servitude Publique Dédiée',
        24: 'Rue de la Ville',
        25: "Autoroute d'État",
        26: 'Route de Comté',
        27: 'Autoroute Inter-États',
        28: 'Servitude Privée',
        29: 'Pipeline',
        30: 'Ligne de Transmission Électrique',
        31: 'Chemin de Fer',
        32: 'Terrain Fédéral',
    },
    adversePartyTypes: {
        1: 'Dommageur',
        2: 'Assurance',
        4: 'Autre',
        5: 'Inconnu',
    },
};
